import { TextField } from '@warp-ds/react/components/textfield';
import type { Ref } from 'react';
import type { PrepackageDestination } from '../../types';
import { getDestinationSummary } from './labels';

type DestinationPickerTriggerProps = {
    inputRef: Ref<HTMLInputElement>;
    isMobile: boolean;
    isOpen: boolean;
    searchQuery: string;
    selectedDestinations: PrepackageDestination[];
    onOpen: () => void;
    onSearchQueryChange: (query: string) => void;
};

export const DestinationPickerTrigger = ({
    inputRef,
    isMobile,
    isOpen,
    searchQuery,
    selectedDestinations,
    onOpen,
    onSearchQueryChange,
}: DestinationPickerTriggerProps) => {
    const selectedSummary = getDestinationSummary(selectedDestinations);

    return (
        <TextField
            ref={inputRef}
            id="destination"
            label={isMobile ? '' : 'Til'}
            placeholder={'Velg reisemål...'}
            value={isMobile ? selectedSummary : isOpen ? searchQuery : selectedSummary}
            type={'search'}
            autoComplete="off"
            aria-haspopup={isMobile ? 'dialog' : undefined}
            aria-expanded={isOpen}
            aria-controls="prepackage-destination-popover"
            onFocus={onOpen}
            onClick={onOpen}
            onChange={(event) => {
                if (isMobile) return;

                onSearchQueryChange(event.target.value);
                if (!isOpen) onOpen();
            }}
        />
    );
};
